import { type AxiosPromise } from 'axios';
import { httpWithAuth } from '~/clients';
import { ADD_FAVORITES } from '~/constants/endpoints';
import type { FavoriteVehicle } from '~/contracts/common';

export type AddFavoriteRequestBody = {
  subscribeToNotifications?: boolean;
  vehicleId: number;
};

export default function addFavorite({
  subscribeToNotifications = false,
  vehicleId
}: AddFavoriteRequestBody): AxiosPromise<FavoriteVehicle[]> {
  return httpWithAuth.post(ADD_FAVORITES, {
    subscribeToWIPNotifications: subscribeToNotifications,
    vehicleId
  });
}
